export let ADDRESS_TARGETS = /*#__PURE__*/function (ADDRESS_TARGETS) {
  ADDRESS_TARGETS["COUNTRY"] = "country";
  ADDRESS_TARGETS["SUBDIVISION"] = "subdivision";
  ADDRESS_TARGETS["CITY"] = "city";
  ADDRESS_TARGETS["ADDRESS_LINE"] = "address_line";
  ADDRESS_TARGETS["ADDRESS_LINE_2"] = "address_line_2";
  ADDRESS_TARGETS["POSTAL_CODE"] = "postal_code";
  ADDRESS_TARGETS["STREET_NAME"] = "street_name";
  ADDRESS_TARGETS["STREET_NUMBER"] = "street_number";
  ADDRESS_TARGETS["APARTMENT"] = "apartment";
  return ADDRESS_TARGETS;
}({});
export function fromAtlasAddress(address) {
  const {
    country,
    subdivision,
    city,
    addressLine,
    streetAddress,
    addressLine2,
    postalCode
  } = address;
  const partial = {};
  if (country) {
    partial.country = country;
  }
  if (subdivision) {
    partial.subdivision = subdivision;
  }
  if (city) {
    partial.city = city;
  }
  if (addressLine) {
    partial.address_line = addressLine;
  } else if (streetAddress != null && streetAddress.formattedAddressLine) {
    partial.address_line = streetAddress == null ? void 0 : streetAddress.formattedAddressLine;
  }
  if (addressLine2) {
    partial.address_line = addressLine2;
  }
  if (postalCode) {
    partial.postal_code = postalCode;
  }
  if (streetAddress != null && streetAddress.apt) {
    partial.apartment = streetAddress == null ? void 0 : streetAddress.apt;
  }
  if (streetAddress != null && streetAddress.name) {
    partial.street_name = streetAddress == null ? void 0 : streetAddress.name;
  }
  if (streetAddress != null && streetAddress.number) {
    partial.street_number = streetAddress.number;
  }
  return partial;
}
export function mergeAddresses(target, source) {
  return Object.keys(target).reduce((merged, property) => {
    const key = property;
    if (source.hasOwnProperty(key)) {
      updateValue(merged, key, source[key]);
    } else {
      updateValue(merged, key, target[key]);
    }
    return merged;
  }, {});
}
function updateValue(object, name, value) {
  object[name] = value;
}
//# sourceMappingURL=address.js.map